import React from "react";

const TONE_CLASSES = {
  info: { bg: "bg-info-faded", accent: "text-info-fg" },
  neutral: { bg: "bg-control-bg", accent: "text-primary" },
};

function FrameLabelPill({ label, value, tone = "info", className = "" }) {
  const { bg, accent } = TONE_CLASSES[tone] || TONE_CLASSES.info;
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full ${bg} px-3 py-1 text-xs whitespace-nowrap text-primary ${className}`}
    >
      {label}
      <strong className={`font-semibold ${accent}`}>{value}</strong>
    </span>
  );
}

export default FrameLabelPill;